<script setup lang="ts">
import { onMounted } from 'vue'
import { useToastrStore } from './toastr'
import { registerToastService } from './toastrService'

const { toasts, remove, show } = useToastrStore()

onMounted(() => { registerToastService({ show }) })
</script>
<template>
    <div class="toast-container">
        <TransitionGroup name="fade">
            <div v-for="toast in toasts" :key="toast.id" @click="remove(toast.id)"
                :class="'toast-' + toast.type">
                <button @click.stop="remove(toast.id)" class="toast-close-button"><i class="fa-solid fa-xmark"></i></button>
                <div class="toast-message" v-html="toast.message"></div>
            </div>
        </TransitionGroup>
    </div>
</template>

